import { CasinoLiveBets } from '@/components/lobby/CasinoLiveBets.js';

export function BelowGame() {
  return (
    <div className="flex flex-col gap-4">
      <CasinoLiveBets />
      {/* RecommendedGames: mount the lobby's existing recommended component here if available. */}
    </div>
  );
}
